import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../common/shared.module';
import { HisTrendsUtlRouting } from './his-trends-utl-routing.module';
import { HisTrendsUtlComponent } from './his-trends-utl.component';
import { BsDropdownModule } from 'ngx-bootstrap';
import { HistoricalTrendsService } from './his-trends-util.services';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [HisTrendsUtlComponent],
  imports: [CommonModule,
          SharedModule,
          FormsModule,
          HisTrendsUtlRouting,
          BsDropdownModule,
          ReactiveFormsModule],
  providers: [HistoricalTrendsService]
})
export class HisTresndsUtlModule {}



// WEBPACK FOOTER //
// ./src/app/t1-his-trends-utl/his-trends-utl.module.ts